// Lib imports
import React, { useState, useCallback, useEffect, useMemo, useContext } from 'react';
import PropTypes from 'prop-types';
import { ThemeContext, Box } from 'grommet';
import { useDispatch } from 'react-redux';

// Core imports
import { setAuthToken, setSsoLogin, setMyOrganisations } from 'granite-admin/utils/auth-singleton';
import { useToast } from 'granite-admin/core/components/Toast';
import EventEmitter from 'granite-admin/utils/event-emitter';
import { ConfigContext } from 'granite-admin/core/components/ConfigProvider';
import LOGIN_MESSAGES from 'granite-admin/messages/login';
import SplitLayout from 'granite-admin/core/components/SplitLayout';
import Loader from 'granite-admin/core/components/Loader';
// Application imports
import { loginClicked } from 'granite-admin/accounts/controllers/user';
import LoginForm from './components/LoginForm';
import { LOGIN_EVENTS } from 'granite-admin/accounts/controllers/constants';
import useQuery from 'granite-admin/utils/useQuery';
import { checkUserAgent } from 'granite-admin/utils/functions';
import { getCookie } from 'granite-admin/utils/storage';
const projectName = process.env.REACT_APP_PROJECT_NAME || 'Granite';
const msg = `Sign in to your ${projectName} Account`;
const sso_ios = process.env.REACT_APP_SSO_IOS_URL || '';
const appleStore = process.env.REACT_APP_APPLE_STORE_URL || '';
const sso_android = process.env.REACT_APP_SSO_ANDROID_URL || '';
const android_package = process.env.REACT_APP_ANDROID_PACKAGE || '';
const Login = ({
  sideContent,
  bannerPadding
}) => {
  const {
    query,
    history
  } = useQuery();
  const {
    errorToast
  } = useToast();
  const eventEmitter = useMemo(() => new EventEmitter(), []);
  const [organisation, setOrganisation] = useState([]);
  const config = useContext(ConfigContext);
  const theme = useContext(ThemeContext);
  const {
    SideContent
  } = config?.sideContentSettings || '';
  const {
    sideProps,
    logoWidth,
    sideWidth,
    configMainPropsLogin
  } = theme?.sideContentSettings || '';
  const dispatch = useDispatch();
  const loader = query.redirectDomain || query.tokenLogin || query.access_token && query.access_token !== 'none';
  console.log('query', query);
  useEffect(() => {
    if (query && query.tokenLogin === 'yes' && query.access_token) {
      setAuthToken(query.access_token);
      history.push('/dashboard');
    } else if (query && query.redirectDomain === 'yes' && query.access_token) {
      handleDomainRedirect(query, dispatch, history);
    } else if (query && query?.access_token?.toLowerCase() === 'none' && query?.error) {
      errorToast(query.error || 'Unable to Sign in, please try again!');
    } else if (query && query.access_token) deepLinkApp(query.access_token, history);
  }, [query, history, errorToast, dispatch]);
  const goToDashboard = useCallback(() => history.push('/dashboard'), [history]);
  const goToOtp = useCallback(email => history.push({
    pathname: '/otp-submit',
    state: email
  }), [history]);
  useEffect(() => {
    const subscription = eventEmitter.getObservable().subscribe(event => {
      switch (event.type) {
        case LOGIN_EVENTS.LOGIN_SUCCESS:
          if (event.data) {
            goToOtp(event.data);
          } else {
            goToDashboard();
          }
          break;
        case LOGIN_EVENTS.LOGIN_FAILURE:
          setOrganisation(event.data.organisations);
          errorToast(event.data.title || LOGIN_MESSAGES.LOGIN_FAILURE);
          break;
        case LOGIN_EVENTS.USER_NOT_EXIST:
          errorToast(LOGIN_MESSAGES.USER_NOT_EXIST);
          break;
        default:
          break;
      }
    });
    return () => subscription.unsubscribe();
  }, [eventEmitter, goToDashboard, goToOtp, errorToast]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, loader ? /*#__PURE__*/React.createElement(Box, {
    align: "center",
    height: "100%",
    justify: "center"
  }, /*#__PURE__*/React.createElement(Loader, null)) : /*#__PURE__*/React.createElement(SplitLayout, {
    mainContent: /*#__PURE__*/React.createElement(LoginForm, {
      loginClicked: loginClicked,
      organisation: organisation,
      setOrganisation: setOrganisation,
      eventEmitter: eventEmitter,
      config: config,
      msg: msg
    }),
    sideContent: SideContent ? /*#__PURE__*/React.createElement(SideContent, null) : sideContent,
    bannerPadding: bannerPadding,
    sideProps: sideProps,
    logoWidth: logoWidth
    // formPad={formPad}
    ,
    sideWidth: sideWidth,
    mainProps: configMainPropsLogin ?? {
      style: {
        marginTop: '3%'
      }
    }
  }));
};
const deepLinkApp = (token, history) => {
  const agent = checkUserAgent();
  if (agent === 'IOS') {
    window.location.href = `${sso_ios}${token}`;
    setTimeout(function () {
      // If the user is still here, open the App Store
      if (!document.hidden) window.location.href = appleStore;
    }, 5000);
  } else if (agent === 'ANDROID') window.location.href = `${sso_android}${token}${android_package}`;else {
    setAuthToken(token);
    setSsoLogin();
    history.push('/dashboard');
  }
};
const handleDomainRedirect = (query, dispatch, history) => {
  const org = JSON.parse(getCookie('organisationData'));
  setAuthToken(query.access_token);
  setMyOrganisations(org);
  dispatch({
    type: 'organisations/UPDATE_SELECTED_ORGANISATION',
    data: org
  });
  dispatch({
    type: 'organisations/UPDATE_ORGANISATIONS',
    data: [org]
  });
  dispatch({
    type: 'accounts/sidebar/RESET_SIDEBAR',
    data: []
  });
  setTimeout(() => history.push('/dashboard'), 0);
};
Login.defaultProps = {
  bannerPadding: 'large',
  sideContent: null
};
Login.propTypes = {
  bannerPadding: PropTypes.string,
  sideContent: PropTypes.node
};
export default Login;